import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { CartaListPage } from '../carta-list/carta-list';
import { CartaServices } from '../services';
import { DishServices } from '../../dish/services';
import { ProductsServices } from '../../products/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaCreateDishProdSelectPage } from '../carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { QRServices } from '../../services/qrServices';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CartaViewSimulatorPage } from './carta-view-simulator/carta-view-simulator';
import { CartaCreateSelectTemplatePage } from '../carta-create/carta-create-select-template/carta-create-select-template';


/**
 * Generated class for the CartaCreateCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-create-customize-view',
    templateUrl: 'carta-create-customize-view.html',
})


export class CartaCreateCustomizeViewPage {
    carta_uid: any;
    valueChanges: any;
    valueChanges_dish: any;
    valueChanges_product: any;
    page_order_show: boolean = false;
    section_order_show: boolean = false;
    section_change_page_show: boolean = false;
    options_menu: boolean = false;
    options_menu_header: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public http: HttpClient,
        public cartaServices: CartaServices,
        public dishServices: DishServices,
        public productsServices: ProductsServices,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public qrServices: QRServices,
        public modalCtrl: ModalController,) {

        this.carta_uid = this.navParams.get('carta_uid');
        this.cartaServices.page_active = 1;
        this.globals.GAtrackView('Cartas', 'Cartas - View', this.globals.restaurant.email, 'View', 'View carta', 'Cartas', '');


        this.cartaServices.cartasDoc = this.cartaServices.afs.doc('cartas/' + this.carta_uid); //Recuperamos el menu
        this.valueChanges = this.cartaServices.cartasDoc.valueChanges().subscribe(value => {
            value.UID = this.carta_uid; //Anadimos el UID a la carta

            this.cartaServices.pages_array_tmp = this.globals.objectToArray(value.pages);

            for (let page of this.globals.objectToArray(value.pages)) {//For pages
                for (let key in page.sections) {//For sections
                    for (let key_dish in page.sections[key].elements) {//For elements
                        if (page.sections[key].elements[key_dish].type == 'dish') {//dishes
                            this.dishServices.dishDoc = this.dishServices.afs.doc('dish/' + page.sections[key].elements[key_dish].uid); //Recuperamos el plato para tener el plato simpre actulizado.
                            this.valueChanges_dish = this.dishServices.dishDoc.valueChanges().subscribe(_value => {
                                //check allergens
                                if (_value.allergens) {
                                    page.sections[key].elements[key_dish].allergens = _value.allergens;
                                } else {
                                    page.sections[key].elements[key_dish].allergens = [];
                                }
                            });
                        } else if (page.sections[key].elements[key_dish].type == 'product') {//products
                            this.productsServices.productDoc = this.productsServices.afs.doc('products/' + page.sections[key].elements[key_dish].uid); //Recuperamos el plato para tener el plato simpre actulizado.
                            this.valueChanges_product = this.productsServices.productDoc.valueChanges().subscribe(_value => {
                                //check allergens
                                if (_value.allergens) {
                                    page.sections[key].elements[key_dish].allergens = _value.allergens;
                                } else {
                                    page.sections[key].elements[key_dish].allergens = [];
                                }
                            });
                        }
                    }
                }
            }

            this.cartaServices.carta_tmp = value;
            this.cartaServices.getIndexOfPage();
        });
    }




    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-carta'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.cartaServices.afs.doc('cartas/' + this.carta_uid).delete();
                        this.globals.GAtrackView('Cartas', 'Cartas - Delete', this.globals.restaurant.email, 'Delete', 'Delete carta', 'Cartas', this.carta_uid);
                        this.valueChanges.unsubscribe();
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();

    }

    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.setRoot(CartaListPage);
        loadingPopup.dismiss();
    }

    desactivateOfDigitalApp() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                'digital_app': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateOnDigitalApp() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                'digital_app': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async activateInTk() {
        if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
            //primero desactivamos todas las cartas activas en tk
            var cartas = await this.cartaServices.getCartasTkActive();
            for (let carta of cartas) {
                if (carta.UID != this.carta_uid) {
                    this.cartaServices.afs.collection('cartas').doc(carta.UID).update({
                        'tk_active': false,
                    });
                }
            }
            //activamos la carta que queremos a tk
            this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                'tk_active': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    desactivateOfTk() {
        if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
            this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                'tk_active': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async updateIonToggle(type, value) {
        switch (type) {
            case 'show_caption': {
                await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                    'show_caption': value,
                });
                break;
            }
            case 'show_enumerate_elements': {
                await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                    'show_enumerate_elements': value,
                });
                break;
            }
            case 'show_enumerate_pages': {
                await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                    'show_enumerate_pages': value,
                });
                break;
            }
            case 'show_logo': {
                await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                    'show_logo': value,
                });
                break;
            }
            case 'active_digital_app': {
                await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                    'digital_app': value,
                });
                break;
            }
            case 'tk_active': {
                if (value == true) {
                    this.activateInTk();
                } else {
                    this.desactivateOfTk();
                }
                break;
            }
        }
    }

    selectTemplate() {
        this.navCtrl.push(CartaCreateSelectTemplatePage, {
            update_state: true,
            carta_uid: this.carta_uid,
        })
    }

    async openNewPage() {

        var last_key = Object.keys(this.cartaServices.carta_tmp.pages)[Object.keys(this.cartaServices.carta_tmp.pages).length - 1];
        if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
        }

        this.cartaServices.carta_tmp.pages[Number(last_key) + 1] = {
            number: this.cartaServices.carta_tmp.pages[Number(last_key)].number + 1,
            sections: {
                0: {
                    name: '',
                    name_ca: '',
                    name_de: '',
                    name_en: '',
                    name_it: '',
                    name_fr: '',
                    order: 1,
                    elements: {},
                }
            },
        }

        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            pages: this.cartaServices.carta_tmp.pages,
        });

        this.cartaServices.page_active = this.cartaServices.carta_tmp.pages[Number(last_key)].number + 1;
        this.cartaServices.cleanEdit();
    }

    openOrderPages() {
        if (!this.page_order_show) {
            this.page_order_show = true;
        } else {
            this.page_order_show = false;
        }
    }
    updatePageOrder() {
        var _obj = {};
        for (var i = 0; this.cartaServices.pages_array_tmp.length > i; i++) {
            _obj[i] = {
                number: i + 1,
                sections: this.cartaServices.pages_array_tmp[i].sections,
            };
        }
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': _obj,
        });
        this.cartaServices.cleanEdit();
        this.openOrderPages();
    }
    async deletePage() {
        //convert to array
        let arr = [];
        for (let k in this.cartaServices.carta_tmp.pages) {
            arr.push(this.cartaServices.carta_tmp.pages[k]);
        }

        //si hay una pagina no se borra
        if (arr.length > 1) {
            //delete
            arr.forEach((item, index) => {
                if (item.number === this.cartaServices.page_active) {
                    arr.splice(index, 1);
                    if (item.number === 1) {
                        this.cartaServices.page_active = 1;
                    } else {
                        this.cartaServices.page_active -= 1;
                    }
                }
            });

            //dar numero en orden las otras paginas
            var count = 1;
            arr.forEach((item, index) => {
                item.number = count;
                count++;
            });

            //create of array to object
            const obj = {};
            arr.forEach((item, index) => {
                obj[index] = item;
            })
            this.cartaServices.carta_tmp.pages = obj;

            //no hi ha res dins object reiniciar
            if (Object.keys(this.cartaServices.carta_tmp.pages).length == 0) {
                this.cartaServices.carta_tmp.pages = {};
            }

            //update para que quede eliminado
            await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
                pages: this.cartaServices.carta_tmp.pages,
            });
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-no-puedes-eliminar-todas-paginas'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }
    reorderPages(indexes) {
        let element = this.cartaServices.pages_array_tmp[indexes.from];
        this.cartaServices.pages_array_tmp.splice(indexes.from, 1);
        this.cartaServices.pages_array_tmp.splice(indexes.to, 0, element);
    }
    openNewSection() {
        this.globals.GAtrackView('Cartas', 'Cartas - Section new - Create', this.globals.restaurant.email, 'Create/Update', 'Create section new', 'Cartas', this.carta_uid);
        this.cartaServices.getIndexOfPage();

        var index = this.globals.objectToArray(this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections).length;

        this.navCtrl.push(CartaCreateDishProdSelectPage, {
            update_state: true,
            carta_uid: this.carta_uid,
            section_index: index,
            page_index: this.cartaServices.edit_page_index,
            section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
            section_name: '',
            new_section: true,
        })
    }
    showSectionOrder() {
        if (!this.section_order_show) {
            this.section_order_show = true;
        } else {
            this.section_order_show = false;
            this.cartaServices.getIndexOfPage();
        }
    }
    showChangeSectionPage() {
        if (!this.section_change_page_show) {
            this.section_change_page_show = true;
        } else {
            this.section_change_page_show = false;
        }
    }
    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.cartaServices.edit_sections.length > i; i++) {
            _obj[i] = {
                name: this.cartaServices.edit_sections[i].name || '',
                name_ca: this.cartaServices.edit_sections[i].name_ca || '',
                name_de: this.cartaServices.edit_sections[i].name_de || '',
                name_en: this.cartaServices.edit_sections[i].name_en || '',
                name_fr: this.cartaServices.edit_sections[i].name_fr || '',
                name_it: this.cartaServices.edit_sections[i].name_it || '',
                order: this.cartaServices.edit_sections[i].order,
                elements: this.cartaServices.edit_sections[i].elements,
            };
        }
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = _obj;
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_tmp.pages,
        });
        this.showSectionOrder();
    }
    reorderSections(indexes) {
        let element = this.cartaServices.edit_sections[indexes.from];
        this.cartaServices.edit_sections.splice(indexes.from, 1);
        this.cartaServices.edit_sections.splice(indexes.to, 0, element);
    }
    async onChange(new_page, original_page, section, page_index, section_index) {

        //delete section from original page
        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections);

        sections_arr.splice(section_index, 1);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            obj[index] = item;
        })
        this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections = obj;
        //volver a ordernar las secciones
        this.reOrderSectionsDelete(original_page);

        //copy section to new page
        var new_index = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections).length;
        this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections[new_index] = section;
        //volver a ordernar las secciones
        this.reOrderSectionsCreate(new_page);


        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.pages_array_tmp,
        });
    }
    getIndex(page) {
        for (let key in this.cartaServices.pages_array_tmp) {
            if (this.cartaServices.pages_array_tmp[key].number == page) {
                return key;
            }
        }
    }
    reOrderSectionsCreate(new_page) {
        var order = 1;
        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            item.order = order;
            obj[index] = item;
            order++;
        });
        this.cartaServices.pages_array_tmp[this.getIndex(new_page)].sections = obj;
    }
    reOrderSectionsDelete(original_page) {
        var order = 1;
        var sections_arr = this.globals.objectToArray(this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections);

        //para que las keys esten bien en order 0,1,2,3..
        const obj = {};
        sections_arr.forEach((item, index) => {
            item.order = order;
            obj[index] = item;
            order++;
        });
        this.cartaServices.pages_array_tmp[this.getIndex(original_page)].sections = obj;
    }

    async printPages() {
        if (this.globals.checkLimitsByLicense('menus', 'print')) {
            this.globals.GAtrackView('Cartas', 'Cartas - Print', this.globals.restaurant.email, 'View', 'Print carta', 'Cartas', '');

            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: this.translate.instant('instant-imprimiendo-carta')
            });
            loadingPopup.present();

            //Format values
            var currency_symbol = this.globals.currency_symbol;
            var logo_format;

            if (!this.globals.logo_url) {
                logo_format = '';
            } else {
                await this.globals.logo_url.subscribe(data => {
                    logo_format = data;
                });
            }

            //Watermark addon comprovation
            var watermark = 'true';
            if (!this.globals.checkLimitsByLicense('menus', 'watermark')) {
                watermark = 'false';
            }

            //Format object menu for POST send
            var carta_send = this.cartaServices.carta_tmp;

            this.http.post(this.globals.api_path + 'carta/a4',
                {
                    carta: carta_send,
                    currency_symbol: currency_symbol,
                    logo: logo_format,
                    lang: this.cartaServices.carta_lang,
                    watermark: watermark,
                    percent: 100,
                }, {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }

    }

    print() {
        if (this.globals.checkLimitsByLicense('menus', 'print')) {
            this.globals.GAtrackView('Cartas', 'Cartas - Print', this.globals.restaurant.email, 'View', 'Print carta', 'Cartas', '');
            window.open(this.globals.share_path + this.globals.domini_sites + '/carta/' + this.cartaServices.carta_tmp.UID + '?lang=' + this.globals.restaurant.lang + '&print=true', '_blank');
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async generateGR() {
        this.qrServices.generateMenuCartaGR(this.cartaServices.carta_tmp.UID, 'carta');
    }

    openSimulator() {
        this.navCtrl.push(CartaViewSimulatorPage);
    }

    onChangeLang(value) {
        //no cambiar seleccionado
        value.target.value = this.globals.restaurant.lang;
        //
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    openVersionPro() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    showCartaOptions() {
        if (this.options_menu) {
            this.options_menu = false;
        } else {
            this.options_menu = true;
        }
    }

    showCartaOptionsHeader() {
        if (this.options_menu_header) {
            this.options_menu_header = false;
        } else {
            this.options_menu_header = true;
        }
    }

    license() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-create-customize-view.ts